import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { releasesAPI } from '../services/api';

function Releases() {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReleases();
  }, []);

  const loadReleases = async () => {
    try {
      const response = await releasesAPI.getAll();
      // Ensure we always have an array
      const data = response?.data || [];
      // Backend already sorts by order, so we just reverse to show newest first
      const releasesArray = Array.isArray(data) ? data : [];
      setReleases([...releasesArray].reverse());
    } catch (error) {
      console.error('Error loading releases:', error);
      setReleases([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="releases" className="releases-section">
        <div className="container">
          <h2 className="section-title">NEW RELEASES</h2>
          <div className="releases-grid">
            <p style={{ color: '#a0a0a0', textAlign: 'center', gridColumn: '1 / -1' }}>Loading releases...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="releases" className="releases-section">
      <div className="container">
        <h2 className="section-title">NEW RELEASES</h2>
        <div className="releases-grid">
          {!Array.isArray(releases) || releases.length === 0 ? (
            <div className="release-card">
              <div className="release-image-placeholder"></div>
              <h3 className="release-artist">Artist Name</h3>
              <p className="release-title">Album Title</p>
              <p className="release-description">Description of the release goes here...</p>
              <a href="#" className="read-more">read more</a>
            </div>
          ) : (
            releases.slice(0, 6).map((release) => (
              <Link 
                key={release.id} 
                to={`/releases/${release.id}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block', height: '100%' }}
              >
                <div className="release-card" style={{ cursor: 'pointer' }}>
                  <div 
                    className="release-image-placeholder"
                    style={release.image ? {
                      backgroundImage: `url(${release.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    } : {}}
                  ></div>
                  <h3 className="release-artist">{release.artist}</h3>
                  <p className="release-title">{release.title}</p>
                  <p className="release-description">{release.description}</p>
                  <span className="read-more">read more</span>
                </div>
              </Link>
            ))
          )}
        </div>
        {releases.length > 0 && (
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <Link 
              to="/releases" 
              style={{ 
                color: '#228b22', 
                textDecoration: 'none', 
                fontSize: '1.2rem',
                fontFamily: 'Bungee, cursive',
                border: '2px solid #228b22',
                padding: '12px 30px',
                display: 'inline-block',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#228b22';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#228b22';
              }}
            >
              VIEW ALL RELEASES →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}

export default Releases;

